import { atom } from "recoil";

export const createConnectorDrawerState = atom({
  key: "createConnectorDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
